import * as XLSX from 'xlsx';

/**
 * Function that creates a file (CSV, XLSX, TXT)
 * @param {Object[]} data - Data to export
 * @param {string} [type=xlsx] - File type
 * @param {string} [name=DataExport] - Filename
 * @returns {Object} - database compliant dataSource
 */
export function export_to(data, type = 'xlsx', name = 'DataExport') {
    const table_content = [...data]
    const wb = XLSX.utils.book_new();
    const pub = XLSX.utils.json_to_sheet(table_content);
    XLSX.utils.book_append_sheet(wb, pub, name);
    XLSX.writeFile(wb, `download-data.${type}`);
}

/**
 * Function that returns an array with sanitized data (for tables)
 * @param {Object[]} data - Data to sanitize
 * @param {string[]} notForTable - Array with the key names to avoid (removes the given keys from the objects)
 * @returns {Object[]} - Sanitized data
 */
export function sanitizeInput(data, notForTable) {
    return [...data.map((d) => {
        let j = { ...d }
        for (const key of Object.keys(j)) {
            if (typeof j[key] === 'object') {
                let temp = { ...j[key] }
                for (const n of Object.keys(j[key])) {
                    temp = { ...temp, ...{ [n]: j[key][n] ? j[key][n].toString() : '' } }
                    if (notForTable.includes(n)) {
                        delete temp[n]
                    }
                }
                j = { ...j, [key]: { ...j[key], ...temp } }
                if (notForTable.includes(key)) {
                    delete j[key]
                }
            } else {
                j[key] = j[key] ? j[key].toString() : ''
                if (notForTable.includes(key)) {
                    delete j[key]
                }
            }
        }
        return j
    })]
}

/**
 * Function that sets the state of a table after filtering
 * @param {Object[]} data - Data to filter
 * @param {String[]} notForTable - Array with the key names to avoid (removes the given keys from the objects)
 * @param {string} filterBy - String to filter with
 * @param {function} setState - Function that sets the state
 */
export function filterTable(data, notForTable = [], filterBy, setState) {
    let filteredData = [...data]
    filteredData = filteredData.filter((d) => {
        for (const dKey in d) {
            if (d[dKey]) {
                if (dKey === 'id' && d.id.toString() === filterBy) {
                    return true
                }
                if (dKey !== 'id') {
                    if (typeof d[dKey] === 'object') {
                        Object.keys(d[dKey]).forEach((oKey) => {
                            if (d[dKey][oKey].toString().toLowerCase().includes(filterBy.toLowerCase())) {
                                return true
                            }
                        })
                    } else if (d[dKey].toString().toLowerCase().includes(filterBy.toLowerCase())) {
                        return true
                    }
                }
            }
        }
        return false
    })
    setState(() => sanitizeInput([...filteredData], notForTable))
}

/**
 * Function that resets the filtered table to its original state
 * @param {Object[]} data - Original data
 * @param {String[]} notForTable - Array with the key names to avoid (removes the given keys from the objects)
 * @param {function} setState - Function that sets the state
 */
export function resetTable(data, notForTable = [], setState) {
    setState(() => sanitizeInput([...data], notForTable))
}